




import { Component, Vue } from 'vue-property-decorator';

@Component({
  props: {
    icon: String,
  },
})
export default class IconComponent extends Vue {
  mouseleave() {
    this.$emit('mouseleave');
  }

  mouseenter() {
    this.$emit('mouseenter');
  }
}
